module.exports = __webpack_public_path__ + "img/basket-fill.3e573376.svg";